import React from 'react';
import { ArrowRight, Clock, FileText, Users } from 'lucide-react';
import type { Survey } from '../../types/surveys/publicSurvey.types';

interface SurveyWelcomeProps {
  survey: Survey;
  primaryColor: string;
  onStart: () => void;
}

export const SurveyWelcome: React.FC<SurveyWelcomeProps> = ({ survey, primaryColor, onStart }) => {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div
            className="h-2"
            style={{ backgroundColor: primaryColor }}
          />
          <div className="p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">{survey.name}</h1>

            {survey.description && (
              <div
                className="prose prose-blue max-w-none mb-6"
                dangerouslySetInnerHTML={{ __html: survey.description }}
              />
            )}

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <div className="flex items-center text-gray-600">
                <FileText className="h-5 w-5 mr-2" style={{ color: primaryColor }} />
                <span>{survey.totalQuestions} Questions</span>
              </div>
              <div className="flex items-center text-gray-600">
                <Clock className="h-5 w-5 mr-2" style={{ color: primaryColor }} />
                <span>~{Math.ceil(survey.totalQuestions * 0.5)} Minutes</span>
              </div>
              <div className="flex items-center text-gray-600">
                <Users className="h-5 w-5 mr-2" style={{ color: primaryColor }} />
                <span>{survey.anonymous ? 'Anonymous' : 'Identified'}</span>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg p-4 mb-8">
              <h3 className="font-semibold text-gray-900 mb-2">Before you begin:</h3>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• You can navigate between pages using Previous/Next buttons</li>
                <li>• Required fields are marked with a red asterisk (*)</li>
                {survey.anonymous && <li>• Your responses will be kept anonymous</li>}
              </ul>
            </div>

            <button
              onClick={onStart}
              className="w-full sm:w-auto px-8 py-3 text-white font-medium rounded-lg flex items-center justify-center transition-colors"
              style={{ backgroundColor: primaryColor }}
            >
              Start Survey
              <ArrowRight className="ml-2 h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};